export default __webpack_public_path__ + "static/media/shopping-cart-continue.75cf5329.png";